<style lang="scss">
  @use "../../../../assets/css/global.scss" as *;
  @use "../../../../assets/css/_colors.scss" as *;
  .toggle {
    $padding: 0.25rem;
    $transitionTime: 0.2s;

    min-height: 2.75rem;
    border: 0;
    border-radius: 0.375rem;
    background-color: $light-gray;
    cursor: pointer;
    display: flex;
    gap: $padding;
    overflow: hidden;
    padding: $padding;
    position: relative;

    .toggle-background {
      width: calc(50% - $padding * 1.5);
      height: calc(100% - $padding * 2);
      border-radius: 0.375rem;
      left: 0;
      margin: $padding;
      position: absolute;
      top: 0;
      transition: transform $transitionTime ease-in-out;
      z-index: 0;
    }

    &.graph-selected .hover-background {
      transform: translateX(calc(100% + $padding));
    }

    &.table-selected .hover-background {
      transform: translateX(0%);
    }

    &:hover > .hover-background {
      opacity: 1;
    }

    .hover-background {
      @extend .toggle-background;
      background-color: $secondary-hover-background-color;
      opacity: 0;
    }

    &.graph-selected .selected-background {
      transform: translateX(0%);
    }

    &.table-selected .selected-background {
      transform: translateX(calc(100% + $padding));
    }

    .selected-background {
      @extend .toggle-background;
      background-color: $primary-color;
    }

    .option {
      width: 50%;
      height: 100%;
      align-items: center;
      display: flex;
      justify-content: center;
      gap: 0.625rem;
      padding: 0 0.75rem;
      position: relative;
      z-index: 1;

      .toggle-icon {
        stroke: $text-black;
        &.selected {
          stroke: white;
        }
        transition: stroke $transitionTime ease-in-out;
      }

      .buttonText {
        color: $text-black;
        &.selected {
          color: white;
        }
        transition: color $transitionTime ease-in-out;
      }
    }
  }
</style>

<script>
  import { onMount } from "@lifecycle";
  import { createEventDispatcher, tick } from "svelte";

  export let selected = "graph"; // 'graph' or 'table'
  export let buttonText = "";

  let hoverRect;

  const dispatch = createEventDispatcher();

  const handleClick = () => {
    selected = selected === "graph" ? "table" : "graph";
    dispatch("toggle-view", selected);
  };

  $: isGraphView = selected === "graph";

  onMount(async () => {
    await tick();
    hoverRect.addEventListener("transitionstart", () => {
      hoverRect.style.visibility = "hidden";
    });
    hoverRect.addEventListener("transitionend", () => {
      hoverRect.style.visibility = "visible";
    });
  });
</script>

<button
  class="toggle {isGraphView ? 'graph-selected' : 'table-selected'}"
  on:click={handleClick}
>
  <div class="selected-background"></div>
  <div class="hover-background" bind:this={hoverRect}></div>
  <div class="option">
    <svg
      class="toggle-icon"
      class:selected={isGraphView}
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66634 5L0.666341 5M6.66634 5L6.66634 2.06641C6.66634 1.69304 6.66634 1.50654 6.59368 1.36393C6.52976 1.23849 6.42785 1.13658 6.30241 1.07266C6.1598 1 5.97298 1 5.59961 1L0.666341 1V5M6.66634 5L10.2663 5C10.6396 5 10.8265 5 10.9691 5.07266C11.0945 5.13658 11.1964 5.23849 11.2603 5.36393C11.333 5.50654 11.333 5.69304 11.333 6.06641V7.93307C11.333 8.30644 11.333 8.49352 11.2603 8.63613C11.1964 8.76157 11.0945 8.86317 10.9691 8.92708C10.8265 8.99975 10.6396 9 10.2663 9H8.66634M0.666341 5L0.666341 9M0.666341 9L0.666276 13L7.59961 13C7.97298 13 8.1598 12.9997 8.30241 12.9271C8.42785 12.8632 8.52976 12.762 8.59368 12.6365C8.66634 12.4939 8.66634 12.3067 8.66634 11.9333V9M0.666341 9L8.66634 9"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </svg>
    {#if buttonText}
      <span class="buttonText" class:selected={isGraphView}>{buttonText}</span>
    {/if}
  </div>
  <div class="option">
    <svg
      class="toggle-icon"
      class:selected={!isGraphView}
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 8.33366H13M1 5.00033H13M1 1.66699H13"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </svg>
    {#if buttonText}
      <span class="buttonText" class:selected={!isGraphView}>{buttonText}</span>
    {/if}
  </div>
</button>
